import React, { FC, useState } from 'react';
import { useUser } from 'store/User/Context';
import styled from 'styled-components';

import LendiWidgetModal from 'components/common/Lendi/LendiWidgetModal';

const StyledLendiButton = styled.button<{ isDarkMode: boolean }>`
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 10px;
    padding: 6px 16px;
    background-color: var(--color-last-message);
    border: none;
    color: ${(props) => props.isDarkMode ? 'black' : 'var(--color-primary)'};
    border-radius: 8px;
    cursor: pointer;
    transition: all 0.2s ease;
    white-space: nowrap;

    img {
        height: 16px;
        width: 16px;
    }

    &:hover {
        background-color: var(--color-alt);
        color: ${(props) => props.isDarkMode ? 'var(--color-primary)' : 'var(--color-white)'};

        img {
            filter: brightness(0) invert(1);
        }
    }
`;

const LendiButton: FC = () => {
    const [isOpen, setIsOpen] = useState(false);
    const { user } = useUser();
    const isDarkMode = user.isDarkMode;

    const handleOpen = (e: React.MouseEvent) => {
        e.stopPropagation();
        setIsOpen(true);
    };

    const handleClose = (e: React.MouseEvent | KeyboardEvent) => {
        e.stopPropagation();
        setIsOpen(false);
    };

    return (
        <>
            <StyledLendiButton onClick={handleOpen} isDarkMode={isDarkMode}>
                Oblicz ratę kredytu
            </StyledLendiButton>
            <LendiWidgetModal isOpen={isOpen} onClose={handleClose} />
        </>
    );
};

export default LendiButton;
